import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ZonaComponent } from './zona.component';

const SECURITY_ROUTES: Routes = [
  { path: 'security/zona', component: ZonaComponent }
];

@NgModule({
  imports: [RouterModule.forChild(SECURITY_ROUTES)],
  exports: [RouterModule]
})
export class ZonaRoutingModule { }
